import React from 'react';

import { FileUploadIcon } from './FileUploadIcon';

export const FileUploadOnlyXmlIcon = () => {
  return <FileUploadIcon onlyXml />;
};
